window.NewsAjaxPageLoad = (function(window,$){
	var NewsAjaxPageLoad = {};
	NewsAjaxPageLoad.loadPage = function(obj, url, noPush){
		if(noPush || NewsAjaxPageLoad.checkUrl(url)){
			$('body').addClass('no-scroll').removeClass('show-header');
			$('footer, .overlay-header, .load-more').css('opacity',0);
			var returnUrl = $(obj).attr('data-page-id') != 1 ? '/news/page/' + $(obj).attr('data-page-id') : '/news';
			$('.js-close-news').attr('data-return-url',returnUrl);

			if(compatibilityCheck.isMobile() || compatibilityCheck.isIE([8,9])){
				$('.js-toggle-navigation').css({
					'-webkit-transform': '-webkit-translateY(-200%)',
					'-moz-transform': '-moz-translateY(-200%)',
					'-ms-transform': '-ms-translateY(-200%)',
					'-o-transform': '-o-translateY(-200%)',
					'transform': 'translateY(-200%)'
				});
				$('.news-article-inner').addClass('active');
				var content = $(obj).find('.card-content').clone();
				$('.inner-news-container .content-area').append(content).append($('<div>').addClass('article-content'));
				setTimeout(function(){
					NewsAjaxPageLoad.makeRequest(url,noPush);
				},100);
			} else {
				setTimeout(function(){
					var image = $(obj).attr('data-bg-image'),
						   _x = $(obj).offset().left + ($(obj).outerWidth() / 2),
						   _y = ($(obj).offset().top - $(window).scrollTop()) + ($(obj).outerHeight() / 2);

					NewsBgAnimation.setClosePosition(_x,_y);
					NewsBgAnimation.changeBgImage(image);
					NewsAjaxPageLoad.animateCardOpen(obj);
					$(obj).addClass('open').removeClass('notFs');
					var content = $(obj).find('.card-content').clone();
					$('.inner-news-container .content-area').append(content).append($('<div>').addClass('article-content'));
					setTimeout(function(){
						NewsAjaxPageLoad.makeRequest(url,noPush);
					},1500);
				},300);
			}
		}
	}

	NewsAjaxPageLoad.checkUrl = function(url){
		return url != window.location.pathname;
	}

	NewsAjaxPageLoad.animateCardOpen = function(obj){
		var _width = $(obj).outerWidth(),
			_height = $(obj).outerHeight(),
			_top = ($(obj).offset().top - $(window).scrollTop()),
			_left = $(obj).offset().left,
			_svg = $(obj).find('svg .clip');

		$(obj).css({
			'position': 'fixed',
			'width': _width+'px',
			'height': _height+'px',
			'top': _top+'px',
			'left': _left+'px',
			'margin': 0,
			'z-index': '400'
		});

		$('.news-card').addClass('anim2 hideArticles');
		$(obj).removeClass('anim2 hideArticles').addClass('hideText');

		var _TL = NewsAjaxPageLoad.buildTimeline(obj);
		setTimeout(function(){
			$(obj).addClass('anim');
			NewsAjaxPageLoad.MorphStage2(obj);
		},1400);
	}

	NewsAjaxPageLoad.buildTimeline = function(obj,reversed){
		var TL = new TimelineMax,
			_width = $(window).width(),
			_height = $(window).height();

		if(reversed){
			var start = [
					      [0.4770833333333333 * _width, 0.3583333333333333 * _height],
					      [0.5859375 * _width, 0.5358333333333333 * _height],
					      [0.5 * _width, 0.5058333333333333 * _height],
					      [0.4130208333333333 * _width, 0.475 * _height]
					    ];
			var end = [
					      [0, _height],
					      [0, 0],
					      [_width, 0],
					      [_width, _height]
					    ];
		} else{ 
			var start = [
					      [0, _height],
					      [0, 0],
					      [_width, 0],
					      [_width, _height]
					    ];
			var end = [
					      [0.4770833333333333 * _width, 0.3583333333333333 * _height],
					      [0.5859375 * _width, 0.5358333333333333 * _height],
					      [0.5 * _width, 0.5058333333333333 * _height],
					      [0.4130208333333333 * _width, 0.475 * _height]
					    ];
		}

		

		var points = [];

		start.forEach(function(point, i) {
	      var tween = TweenMax.to(point, 1.5, end[i]);
	      end[i].onUpdate = function() {
	        points.push(point.join());
	        // Every 4 point update clip-path.
	        if (points.length === end.length) {
	          $(obj).find('.clip').attr('points', points.join(' '));
	          // Reset.
	          points = [];
	        };
	      }.bind(obj);
	      tween.vars.ease = Expo.easeInOut;
	      // Add at position 0.
	      TL.add(tween, 0);
	    }, obj);
		return TL;
	}

	NewsAjaxPageLoad.MorphStage2 = function(obj){
		$(obj).addClass('fullscreen');
		NewsBgAnimation.animate('open');
		setTimeout(function(){
			NewsAjaxPageLoad.MorphStage3(obj);
		},1600);
	}

	NewsAjaxPageLoad.MorphStage3 = function(obj){
		NewsBgAnimation.moveCircle();
		$(obj).addClass('no-trans').find('.bg-image').addClass('open');
		$('.news-inner, .news-article-inner').addClass('active');
	}

	NewsAjaxPageLoad.calcTrianglePoints = function(){
		var points = '',
			width = $(window).width(),
			height = $(window).height();
		points = (0.4770833333333333 * width) + ',' + (0.3583333333333485 * height) + ' ' + (0.5859375 * width) + ',' + (0.5358333333333333 * height) + ' ' + (0.5 * width) + ',' + (0.5058333333333332 * height) + ' ' + (0.4130208333333485 * width) + ',' + (0.47500000000002274 * height);
		return points;
	}

	NewsAjaxPageLoad.makeRequest = function(url,noPush){
		var newUrl = url.replace('/news/',''),
			ajaxUrl = '/news?get_article=true&ajax=true&url=' + newUrl;
		$.ajax({
            url: ajaxUrl,
            method: "GET",
            dataType: "json"
        }).success(function (data) {
           if(data.activeArticle != 0){
           		var content = data.articleInformation.content,
           			shareUrl = window.location.origin + '/news/' + data.articleInformation.title_url,
           			sharingDiv = $('<div>').addClass('share-information')
									.append($('<div>').addClass("share-icons")
					           				.append($('<a>').attr('target','_blank').addClass('share-icon twitter-icon').attr('href','https://twitter.com/home?status=Check%20out%20this%20news%20article%20from%20AE%20Williams%20' + shareUrl)
					           						.append($('<span>').addClass('icon'))
					           						.append($('<span>').addClass('text').text('Share on twitter')))
											.append($('<a>').attr('target','_blank').addClass('share-icon facebook-icon').attr('href','https://www.facebook.com/sharer/sharer.php?u=' + shareUrl)
													.append($('<span>').addClass('icon'))
													.append($('<span>').addClass('text').text('Share on facebook')))
											.append($('<a>').attr('target','_blank').addClass('share-icon google-icon').attr('href','https://plus.google.com/share?url=' + shareUrl)
													.append($('<span>').addClass('icon'))
													.append($('<span>').addClass('text').text('Share on google+')))
											.append($('<a>').attr('target','_blank').addClass('share-icon linkedin-icon').attr('href','https://www.linkedin.com/shareArticle?mini=true&url=' + shareUrl + '&title=' + data.articleInformation.title + '&summary=' + data.articleInformation.meta_desc)
												.append($('<span>').addClass('icon'))
												.append($('<span>').addClass('text').text('Share on Linkedin')))),
					authorDiv = $('<div>').addClass('author-information')
											.append($('<span>').addClass('author-image').attr('style','background: url("' + data.articleInformation.author.author_img + '") no-repeat center center; background-size: cover;'))
											.append($('<div>').addClass('author-info')
												.append($('<h2>').text('Posted by ' + data.articleInformation.author.author_name))
												.append($('<p>').text(data.articleInformation.author.author_profile))
											);

           		$('.inner-news-container .content-area .article-content').append([content, sharingDiv, authorDiv]);
           		setTimeout(function(){
           			$('.inner-news-container .content-area .article-content').slideDown(400);
           		});
           		noPush || window.history.pushState({}, '', url);
           		try{
	        		ga('send', 'pageview');
	        	} catch (e) {}
           } else{
           		window.location.href = url;
           }
        }).fail(function () {
        	window.location.href = url;
        });
	}

	NewsAjaxPageLoad.closeInner = function(noPush){
		var returnUrl = $('.js-close-news').attr('data-return-url');
		if(compatibilityCheck.isMobile()){
			$('body').removeClass('no-scroll').addClass('show-header');
			$('footer, .overlay-header, .load-more').css('opacity','');
			$('.news-article-inner').removeClass('active');
			$('.js-toggle-navigation').css({
					'-webkit-transform': '-',
					'-moz-transform': '',
					'-ms-transform': '',
					'-o-transform': '',
					'transform': ''
			});
			setTimeout(function(){
				$('.inner-news-container .content-area').html('');
			},2400);
		} else {
			$('body').removeClass('no-scroll');
			$('.js-news-load.open').removeClass('no-trans').find('.bg-image').removeClass('open');
			$('.news-inner, .news-article-inner').removeClass('active');
			setTimeout(function(){
				var obj = $('.js-news-load.open'),
					_TL = NewsAjaxPageLoad.buildTimeline(obj,true);
				$(obj).removeClass('fullscreen');
				NewsBgAnimation.animate('close');
				setTimeout(function(){
					$('.news-card').removeClass('hideArticles');
					$('.js-news-load.open').removeClass('hideText');
					$('body').removeClass('no-scroll');
					$('footer, .overlay-header, .load-more').css('opacity','');
					$('.inner-news-container .content-area').html('');
					setTimeout(function(){
						$('.js-news-load.open').removeClass('open anim').attr('style','');
						setTimeout(function(){
							$('.news-card').addClass('notFs').removeClass('anim2');
						},400);
					},200);
				},1800);
			},400);
		}
		noPush || window.history.pushState({}, '', returnUrl);
		try{
    		ga('send', 'pageview');
    	} catch (e) {}
	}

	NewsAjaxPageLoad.loadMoreArticles = function(page,all){
		$('.js-load-more').hide();
		var ajaxUrl = '/news?news_articles=true&ajax=true&page=' + page + '&get_all=' + (all ? 'true' : 'false');
		$.ajax({
            url: ajaxUrl,
            method: "GET",
            dataType: "json"
        }).success(function (data) {
           var articles  = data.articles;
           if(all){
          		$('.news-holder').html('');
           }
           $(articles).each(function(index,article){
           		var itemPage = page;
           		if(all){
           			itemPage = Math.ceil(index / 6) + 1;
           		}
           		var width = $(window).width(),
           			height = $(window).height(),
           			svgCode = '<svg viewBox="0 0 ' + width + ' ' + height + '" preserveAspectRatio="xMidYMid slice">\
										  <defs>\
									        <clipPath id="clipPath' + article.id + '">\
									          <polygon class="clip" points="0 0,' + width + ' 0,' + width + ' ' + height + ',0 ' + height +'"></polygon>\
									        </clipPath>\
									      </defs>\
									      <image clip-path="url(#clipPath' + article.id + ')" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" xlink:href="' + article.img + '"></image>\
									      <image class="overlay-filter" clip-path="url(#clipPath' + article.id + ')" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" xlink:href="/images/png/news-inner-overlay.png"></image>\
									</svg>';

           		var articleHolder = $('<div>').addClass("news-card-holder").append($('<a>').attr('href','/news/' + article.title_url).attr('data-article-id',article.id).attr('data-page-id',itemPage).addClass('news-card js-news-load notFs').attr('data-bg-image',article.img)
									.append($('<div>').addClass('bg-image').html(svgCode))
									.append($('<div>').addClass('card-content')
										.append($('<div>').addClass('button-content')
											.append($('<h1>').html(article.title))
											.append($('<span>').addClass('meta-info').text('Posted by ' + article.author.author_name + ' on ' + article.date))
										)));
				
				$('.news-holder').append(articleHolder);
           });
           if(data.totalArticles > page * 6){
           		$('.js-load-more').show();
           }
           $('.js-load-more').attr('data-page',page);
           var pushUrl = page > 1 ? '/news/page/' + page : '/news';
           window.history.pushState({}, '', pushUrl);
           try{
        		ga('send', 'pageview');
        	} catch (e) {}
        }).fail(function () {
        	$('.js-load-more').show();
        });
	}

	return NewsAjaxPageLoad;
})(window,$);